import { createAtomObserver } from '@exodus/atoms';
const applicationLifecyclePlugin = ({ port, lockedAtom, lockHistoryAtom, restoreAtom, backedUpAtom, autoLockTimerAtom, walletCreatedAtAtom, }) => {
    const observers = [
        createAtomObserver({ port, atom: lockedAtom, event: 'locked' }),
        createAtomObserver({ port, atom: lockHistoryAtom, event: 'lockHistory' }),
        createAtomObserver({ port, atom: restoreAtom, event: 'restore' }),
        createAtomObserver({ port, atom: backedUpAtom, event: 'backedUp' }),
        createAtomObserver({ port, atom: autoLockTimerAtom, event: 'autoLockTimer' }),
        createAtomObserver({ port, atom: walletCreatedAtAtom, event: 'walletCreatedAt' }),
    ];
    const onStart = ({ isRestoring }) => {
        void restoreAtom.set(isRestoring);
    };
    const onLoad = async () => {
        observers.forEach((observer) => observer.start());
    };
    const onImport = () => {
        void backedUpAtom.set(true);
        void restoreAtom.set(true);
    };
    const onAssetsSynced = async () => {
        void restoreAtom.set(false);
    };
    const onStop = () => {
        observers.forEach((observer) => observer.unregister());
    };
    const onClear = async () => {
        await Promise.all([backedUpAtom.set(undefined), autoLockTimerAtom.set(undefined)]);
    };
    return { onStart, onLoad, onImport, onAssetsSynced, onStop, onClear };
};
const applicationLifecyclePluginDefinition = {
    id: 'applicationLifecyclePlugin',
    type: 'plugin',
    factory: applicationLifecyclePlugin,
    dependencies: [
        'port',
        'lockedAtom',
        'lockHistoryAtom',
        'restoreAtom',
        'backedUpAtom',
        'autoLockTimerAtom',
        'walletCreatedAtAtom',
    ],
    public: true,
};
export default applicationLifecyclePluginDefinition;
